import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';

import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

import { ProcessingComponent } from '../../../components';
import { AppInitService, IInsectaPermissions } from '../../../services/app-init.service';

@Component({
  selector: 'app-lookup-list',
  standalone: true,
  imports: [ButtonModule, CardModule, CommonModule, FormsModule, RouterModule, ProcessingComponent],

  templateUrl: 'lookup-list.component.html'
})
export class LookupListComponent implements OnInit {
  permissions!: IInsectaPermissions;
  pageVars = {
    isReady: false
  };

  primaryList: any[] = [];
  secondaryList: any[] = [];

  constructor(
    private router: Router,
    private appInit: AppInitService
  ) {}

  ngOnInit() {
    this.permissions = this.appInit.permissions;

    this.primaryList = [];
    this.secondaryList = [];

    if (this.permissions.configureContainers) {
      this.primaryList.push({
        title: 'Containers',
        description: 'Packaging to hold substrate and/or insects',
        path: '/admin/containers'
      });
    }

    if (this.permissions.configureLocations) {
      this.primaryList.push({
        title: 'Locations',
        description: 'Places where orders are delivered',
        path: '/admin/locations'
      });
    }

    if (this.permissions.configureSubstrates) {
      this.primaryList.push({
        title: 'Substrate',
        description: 'Nutritional medium used to feed insects',
        path: '/admin/substrates'
      });
    }

    if (this.permissions.configureVendors) {
      this.primaryList.push({
        title: 'Vendors',
        description: 'Those organizations from which insects and/or substrate may be ordered',
        path: '/admin/vendors'
      });
    }

    if (this.permissions.configureInsects) {
      this.primaryList.push({
        title: 'Insects',
        description: 'Add new insects, edit existing insects, and manage insect settings',
        path: '/admin/insects'
      });
    }

    if (this.permissions.configureProjects) {
      this.secondaryList.push({
        title: 'Projects',
        description: 'Research projects for which materials are ordered',
        path: '/admin/projects'
      });
    }

    if (this.permissions.configureContainerTypes) {
      this.secondaryList.push({
        title: 'Container Types',
        description: 'The different types of containers',
        path: '/admin/containertypes'
      });
    }

    if (this.permissions.configureContainmentTypes) {
      this.secondaryList.push({
        title: 'Containment Types',
        description: 'The different types of Containments',
        path: '/admin/containmenttypes'
      });
    }

    if (this.permissions.configureGrowthStages) {
      this.secondaryList.push({
        title: 'Growth Stage',
        description: 'Growth Stages are the maturity cycle of an insect',
        path: '/admin/growthstages'
      });
    }

    if (this.permissions.configureLocationTypes) {
      this.secondaryList.push({
        title: 'Location Types',
        description: 'Categories for places where orders are delivered',
        path: '/admin/locationtypes'
      });
    }

    if (this.permissions.configurePermits) {
      this.secondaryList.push({
        title: 'Permits',
        description: 'Regulatory approvals for insects at a location',
        path: '/admin/permits'
      });
    }

    if (this.permissions.configureUnitsOfMeasure) {
      this.secondaryList.push({
        title: 'Units of Measure',
        description: 'Units of Measure are used for amounts and calculations',
        path: '/admin/unitsofmeasure'
      });
    }

    if (this.permissions.configureVariantTypes) {
      this.secondaryList.push({
        title: 'Variant Types',
        description: 'Variant Types are a list of potential insect variations',
        path: '/admin/varianttypes'
      });
    }

    this.primaryList = this.primaryList.sort((a, b) => (a.title > b.title ? 1 : -1));
    this.secondaryList = this.secondaryList.sort((a, b) => (a.title > b.title ? 1 : -1));

    this.pageVars.isReady = true;
  }

  goClick(path: string) {
    this.router.navigateByUrl(path);
  }
}
